.messagesModal {
  .body {
    max-height: 100%;
  }
  max-height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0;
  padding-top: 12px;
  position: relative;
  height: fit-content;
  width: 100%;
  max-width: 500px;
}

.messagesModal .body p {
  text-align: left;
}

.body {
  &.bodyWithoutOverflow {
    overflow: unset;
  }
  margin-top: 12px;
  max-height: 100%;
  padding: 20px;
  width: 100%;
  height: 100%;
  margin: 0;

  & > .body {
    padding: 5px;
    margin: 0;
  }
}

.header {
  padding: 0 12px;
}

.loginBody {
  min-width: 450px;
}

.sfStoreMediaContainer {
  max-width: inherit;
  padding-left: 20px;
  margin-top: 24px;
}

.field.fieldCheckbox {
  justify-content: flex-end;
  flex-direction: row-reverse;
  gap: 6px;
  align-items: center;
}

.clickableLabel {
  cursor: pointer;
  user-select: none;
}

.fieldGroup {
  display: flex;
  width: 100%;
  justify-content: space-evenly;
  gap: 24px;
}

.field {
  display: flex;
  margin-bottom: 10px;
  width: 100%;
  flex-direction: column;

  &.hidden {
    display: none;
  }
  .filedLabel {
    flex-shrink: 0;
  }

  & > div {
    margin: 0;
  }
}

.objectRowContainer {
  max-height: 40px;
}

.messagesModal .tabs {
  &.azureBlobTabs {
    grid-template-columns: 1fr 1fr 1fr;
  }
  font-size: 11px;
  white-space: nowrap;
  display: grid;
  grid-template-columns: 1fr 1fr;
  text-transform: uppercase;
  position: sticky;
  top: 0;
  z-index: 1;
  margin-bottom: 4px;

  > div {
    text-align: center;
    padding: 9px 15px;
  }

  > span {
    padding: 9px 0;
  }
}

.serverToServer {
  margin: 24px 0;
}

.serverToServerOnly {
  margin-bottom: 24px;
}

.reconnectSalesforce {
  margin-top: 24px;
}

.reconnectSalesforceText {
  font-size: 14px;
}

.reconnectSalesforceButton {
  margin-top: 24px;
  display: flex;
  justify-content: center;
}

.hubspotConnect {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 12px;
}

.description {
  font-weight: 500;
  font-size: 14px;
  margin-bottom: 13px;
}

.subDescription {
  @include themify($themes) {
    color: themed("neutral-primary");
  }
  font-weight: 500;
  font-size: 12px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
}

.errorText {
  font-size: 14px;
  font-weight: 500;
  @include themify($themes) {
    color: themed("error-primary");
  }
}

.questionMark {
  margin-right: 6px;
}

.longTranscribeLabel {
  display: flex;
  align-items: center;

  .filedLabel {
    margin-right: 6px;
  }
}
